import { createContext } from 'react';
import type { MeResponse } from '../api/types';

export type AuthStatus = 'initializing' | 'unauthenticated' | 'authenticated';

export interface AuthContextValue {
  status: AuthStatus;
  me: MeResponse | null;
  error: string | null;
  login: (email: string, password: string) => Promise<void>;
  loginWithEntra: () => Promise<void>;
  logout: () => void;
  refresh: () => Promise<void>;
  hasPermission: (key: string) => boolean;
  hasAnyPermission: (...keys: string[]) => boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
